/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_EmailInputs */

const en_wallet_card_email = /** @type {(inputs: Wallet_Card_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const fr_wallet_card_email = /** @type {(inputs: Wallet_Card_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courriel`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Wallet_Card_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_email = /** @type {((inputs?: Wallet_Card_EmailInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_EmailInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_email(inputs)
	return fr_wallet_card_email(inputs)
});